import { trpc } from '@/shared/api';

/** 한 목적의 기획전 목록(어드민, 숨김 포함) — 배열 순서가 고객 화면 카드 순서다. */
export const useExhibitionsQuery = (purposeId: string) =>
  trpc.productManagement.exhibitions.list.useQuery({ purposeId });
